module.exports = __webpack_public_path__ + "static/media/__Store-Analytics.0f402a0b.svg";